import React from 'react';

interface UserIdentityProps {
    name?: string | undefined;
    email?: string | undefined;
    avatarUrl?: string | undefined;
    initialsBgColor?: string | undefined;
    initialsTextColor?: string | undefined;
    size?: 'sm' | 'md' | undefined;
    className?: string | undefined;
}

const getInitials = (name = ''): string => {
    return name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2) || '?';
};

const UserIdentity: React.FC<UserIdentityProps> = ({
    name,
    email,
    avatarUrl,
    initialsBgColor = 'bg-primary/10',
    initialsTextColor = 'text-primary',
    size = 'md',
    className = '',
}) => {
    const displayName = name || 'Unknown';
    const sizeClasses = size === 'sm' ? 'w-8 h-8 text-[10px]' : 'w-9 h-9 text-xs';

    return (
        <div className={`flex items-center gap-3 ${className}`.trim()}>
            {avatarUrl ? (
                <img src={avatarUrl} alt="" className={`${sizeClasses} rounded-full object-cover`} />
            ) : (
                <div className={`${sizeClasses} rounded-full ${initialsBgColor} ${initialsTextColor} flex items-center justify-center font-semibold`}>
                    {getInitials(displayName)}
                </div>
            )}
            <div className="min-w-0">
                <p className="text-sm font-medium text-slate-900 truncate">{displayName}</p>
                {email && <p className="text-xs text-slate-500 truncate">{email}</p>}
            </div>
        </div>
    );
};

export default UserIdentity;
